var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSauna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 16.962L1.33501 15.5559C1.72696 14.6138 2.64715 14 3.66751 14H7.81153C8.8291 14 9.74734 14.6105 10.1411 15.5488L10.75 17",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85526 6.21053C6.01797 6.21053 6.96053 5.26797 6.96053 4.10526C6.96053 2.94256 6.01797 2 4.85526 2C3.69256 2 2.75 2.94256 2.75 4.10526C2.75 5.26797 3.69256 6.21053 4.85526 6.21053Z",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.67969V8.31127C4.75 10.1716 6.25809 11.6797 8.11842 11.6797H9.54795C10.9549 11.6797 12.2136 12.5541 12.7046 13.8725L13.75 16.6797",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2148 1.67969L13.3444 2.6941C13.4515 3.53203 13.0759 4.35851 12.3743 4.82898C11.7044 5.27823 11.3292 6.05423 11.3933 6.85831L11.4437 7.49171",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6523 1.71875L16.7819 2.73316C16.889 3.57109 16.5134 4.39757 15.8118 4.86804C15.1419 5.31729 14.7667 6.09329 14.8308 6.89738L14.8812 7.53077",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36323 14.3871L2.48633 7.67969",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauna);
export default __webpack_public_path__ + "static/media/sauna.79be8e9f.svg";
export { ForwardRef as ReactComponent };